// A HARD redirect re-initializes the app from the new URL, so these must be carried by hand or the token bearer
// is logged out — `retainSearchParams` only covers client navigations.
const SDK_PARAMS = ['token', 'lang', 'clientId', 'ref'] as const

// localStorage is per-ORIGIN, but a token link authenticates a DIFFERENT entity than the session owning the blob,
// so a token document would rehydrate the owner's cache before React hydrates — clobbering the identity-scoped
// queries its SSR HTML was built from (#418) and writing the entity's data back over the owner's blob.
// isTopLevel is passed in because window.self === window.top is client-only: this makes the PERSISTER inert
// rather than changing the rendered tree, which must stay identical on both sides.
export function documentOwnsPersistedCache(search: string, isTopLevel: boolean): boolean {
  if (!isTopLevel) return false
  // Truthy, not `has`: a bare `?token=` is not a session (main.tsx sends the Bearer header on truthiness).
  return !new URLSearchParams(search).get('token')
}

// Never overrides params the target already sets.
export function withSdkParams(path: string): string {
  if (typeof window === 'undefined') return path
  const url = new URL(path, window.location.origin)
  const current = new URLSearchParams(window.location.search)
  for (const key of SDK_PARAMS) {
    const value = current.get(key)
    if (value && !url.searchParams.has(key)) url.searchParams.set(key, value)
  }
  return `${url.pathname}${url.search}${url.hash}`
}
